import * as React from 'react';
import clsx from 'clsx';

interface AuthDividerProps {
  /** Label displayed between the two lines. */
  text: string;
  /** Additional Tailwind classes for the container. */
  className?: string;
}

/** Horizontal divider with centered label. Green line on mobile, dark on desktop. */
export const AuthDivider: React.FC<AuthDividerProps> = ({ text, className }) => (
  <div className={clsx('flex w-full items-center justify-between gap-3', className)}>
    <div className='h-px flex-1 border-t border-[#706E6E] bg-[#D9FBBE] fold:border-0 fold:bg-brand-800' />
    <span className='shrink-0 font-sans text-[length:var(--vs-14,14px)] font-normal text-white fold:text-brand-800'>
      {text}
    </span>
    <div className='h-px flex-1 border-t border-[#706E6E] bg-[#D9FBBE] fold:border-0 fold:bg-brand-800' />
  </div>
);
